/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBodyData =
  {
    message: string;
  };

/**
 * Rate limited
 */
export class UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBodyData;

  constructor(
    err:
      UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBodyData =
  {
    message: string;
  };

/**
 * Conflict
 */
export class UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBodyData;

  constructor(
    err:
      UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBodyData =
  {
    message: string;
  };

/**
 * Not found
 */
export class UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBodyData;

  constructor(
    err:
      UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBodyData =
  {
    message: string;
  };

/**
 * Forbidden
 */
export class UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBodyData;

  constructor(
    err: UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type UpdateServiceAccountApiKeyAuthServiceAccountsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class UpdateServiceAccountApiKeyAuthServiceAccountsResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UpdateServiceAccountApiKeyAuthServiceAccountsResponseBodyData;

  constructor(
    err: UpdateServiceAccountApiKeyAuthServiceAccountsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateServiceAccountApiKeyAuthServiceAccountsResponseBody";
  }
}

/**
 * Bad request
 */
export type UpdateServiceAccountApiKeyResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class UpdateServiceAccountApiKeyResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateServiceAccountApiKeyResponseBodyData;

  constructor(
    err: UpdateServiceAccountApiKeyResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateServiceAccountApiKeyResponseBody";
  }
}

/** @internal */
export const UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody
  > = z.instanceof(
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody
  > = z.instanceof(
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody
  > = z.instanceof(
    UpdateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$inboundSchema:
  z.ZodType<
    UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$outboundSchema:
  z.ZodType<
    UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody
  > = z.instanceof(
    UpdateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateServiceAccountApiKeyAuthServiceAccountsResponseBody$inboundSchema:
  z.ZodType<
    UpdateServiceAccountApiKeyAuthServiceAccountsResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateServiceAccountApiKeyAuthServiceAccountsResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateServiceAccountApiKeyAuthServiceAccountsResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const UpdateServiceAccountApiKeyAuthServiceAccountsResponseBody$outboundSchema:
  z.ZodType<
    UpdateServiceAccountApiKeyAuthServiceAccountsResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateServiceAccountApiKeyAuthServiceAccountsResponseBody
  > = z.instanceof(UpdateServiceAccountApiKeyAuthServiceAccountsResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateServiceAccountApiKeyResponseBody$inboundSchema: z.ZodType<
  UpdateServiceAccountApiKeyResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UpdateServiceAccountApiKeyResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UpdateServiceAccountApiKeyResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateServiceAccountApiKeyResponseBody$outboundSchema: z.ZodType<
  UpdateServiceAccountApiKeyResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateServiceAccountApiKeyResponseBody
> = z.instanceof(UpdateServiceAccountApiKeyResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
